var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLang = function SvgLang(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0m2.32 7.583H4.68c.128 2.978 1.227 5.25 2.32 5.25s2.192-2.272 2.32-5.25m-5.809 0H1.196a5.84 5.84 0 0 0 3.511 4.783c-.687-1.173-1.122-2.877-1.196-4.783m9.294 0h-2.316c-.074 1.907-.509 3.61-1.196 4.782a5.84 5.84 0 0 0 3.512-4.781M4.708 1.636l-.065.028a5.84 5.84 0 0 0-3.447 4.754h2.316c.073-1.907.508-3.61 1.195-4.782M7 1.167h-.044c-1.078.06-2.15 2.312-2.277 5.25h4.642C9.19 3.439 8.093 1.167 7 1.167m2.293.468.043.074c.662 1.169 1.08 2.841 1.152 4.708h2.316a5.84 5.84 0 0 0-3.511-4.782"
  })));
};
export default SvgLang;